/**
 * API client for backend - uses fetch with auth token
 */

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const getToken = () => localStorage.getItem('token');

export const setToken = (token) => {
  if (token) localStorage.setItem('token', token);
  else localStorage.removeItem('token');
};

const getLoginPath = () => {
  if (typeof window === 'undefined') return '/fa/login';
  const stored = localStorage.getItem('haryad-locale') || 'fa';
  const pathCode = window.location.pathname.split('/').filter(Boolean)[0];
  const locale = /^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/i.test(pathCode || '') ? pathCode : stored;
  return `/${locale}/login?session=expired`;
};

async function request(endpoint, options = {}) {
  const url = endpoint.startsWith('http') ? endpoint : `${BASE_URL}${endpoint}`;
  const token = getToken();
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const headers = {
    ...(!isFormData && { 'Content-Type': 'application/json' }),
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  const res = await fetch(url, { ...options, headers });
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    if (res.status === 401) {
      setToken(null);
      localStorage.removeItem('user');
      if (typeof window !== 'undefined' && !window.location.pathname.includes('/login')) {
        window.location.href = getLoginPath();
      }
    }
    const err = new Error(data.message || 'خطای سرور');
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

const resolveDownloadFilename = (disposition, fallback = 'download') => {
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  const fallbackMatch = disposition.match(/filename="?([^";]+)"?/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch (_) {
      return utf8Match[1];
    }
  }
  return fallbackMatch?.[1] || fallback;
};

async function downloadRequest(endpoint, options = {}, fallbackFilename = 'download') {
  const url = endpoint.startsWith('http') ? endpoint : `${BASE_URL}${endpoint}`;
  const token = getToken();
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const res = await fetch(url, {
    ...options,
    headers: {
      ...(options.body && !isFormData && { 'Content-Type': 'application/json' }),
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    if (res.status === 401) {
      setToken(null);
      localStorage.removeItem('user');
      if (typeof window !== 'undefined' && !window.location.pathname.includes('/login')) {
        window.location.href = getLoginPath();
      }
    }
    const err = new Error(data.message || 'دانلود فایل انجام نشد');
    err.status = res.status;
    err.data = data;
    throw err;
  }

  const disposition = res.headers.get('Content-Disposition') || '';
  return {
    blob: await res.blob(),
    filename: resolveDownloadFilename(disposition, fallbackFilename),
  };
}

const download = (endpoint) => downloadRequest(endpoint, {}, 'product.zip');
const downloadPost = (endpoint, body) => downloadRequest(
  endpoint,
  { method: 'POST', body: JSON.stringify(body) },
  'haryad-backup.zip'
);

export const api = {
  get: (path) => request(path),
  post: (path, body) => request(path, { method: 'POST', body: JSON.stringify(body) }),
  upload: (path, formData) => request(path, { method: 'POST', body: formData }),
  download,
  downloadPost,
  put: (path, body) => request(path, { method: 'PUT', body: JSON.stringify(body) }),
  patch: (path, body) => request(path, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: (path) => request(path, { method: 'DELETE' }),
};

export default api;
